if (!customElements.get('toolless-image-swiper')) {
    class ToollessImageSwiper extends HTMLElement {

        constructor() {
            super();
            this.swiper = this.querySelector('.swiper');
            this.thumbContainer = this.querySelector('.toolless-image-swiper-pc__thumb');
        }

        connectedCallback() {
            const prevButton = this.querySelector('.swiper-button-prev');
            const nextButton = this.querySelector('.swiper-button-next');
            this.mySwiper = new Swiper(this.swiper, {
                spaceBetween: 20,
                slidesPerView: 1,
                slidesPerGroup: 1,
                observer: true,
                resizeObserver: true,
                navigation: {
                    nextEl: nextButton || undefined,
                    prevEl: prevButton || undefined,
                },
                on: {
                    slideChange: this.synchronous.bind(this),
                },
            });

            const thumbItems = this.thumbContainer.querySelectorAll('.toolless-image-swiper-pc__thumb__group');
            thumbItems.forEach(thumbItem => {
                thumbItem.addEventListener('click', this.clickThumb.bind(this));
            });
        }

        clickThumb(event) {
            const thumbItems = this.thumbContainer.querySelectorAll('.toolless-image-swiper-pc__thumb__group');

            thumbItems.forEach(item => item.classList.remove('active'));

            const clickedThumb = event.currentTarget;
            clickedThumb.classList.add('active');

            const index = parseInt(clickedThumb.getAttribute('data-group'), 10);
            const realIndex = index - 1;

            this.mySwiper.slideTo(realIndex);
        }

        synchronous() {
            const activeIndex = this.mySwiper.realIndex;
            const thumbItems = this.thumbContainer.querySelectorAll('.toolless-image-swiper-pc__thumb__group');

            thumbItems.forEach(item => item.classList.remove('active'));

            if (thumbItems[activeIndex]) {
                thumbItems[activeIndex].classList.add('active');
            }

            console.log('Swiper slide changed. ActiveIndex is ' + activeIndex);
        }
    }

    customElements.define('toolless-image-swiper', ToollessImageSwiper);
}
